import ERP from "../ERP.mjs";
import View from "../View.mjs";

export default {

    async pegaGrupoPorNome(grupoNome = ""){

        let grupo;

        try{

            grupo = await ERP.getOneWithView(View.GRUPO_PEGA_GRUPO_POR_NOME,[
                {
                    name: "nome",
                    dataType: "String",
                    value: grupoNome
                }
            ]);
            if(grupo.status != 200){
                throw grupo;
            }

            console.log(grupo);

        }catch(e){

            console.log(e);
            return grupo;

        }

        return grupo;

    },

}